module.exports = __webpack_public_path__ + "static/img/bulibuli.b1cdf8cd.png";